
import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";

export const AnalyticsTab = () => {
  const { language } = useLanguage();

  return (
    <Card className="bg-card/80 backdrop-blur-sm border shadow-lg">
      <CardHeader>
        <CardTitle className="flex items-center gap-3 text-xl">
          <div className="h-12 w-12 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-md">
            <BarChart3 className="h-6 w-6 text-white" />
          </div>
          {language === 'ar' ? 'تحليلات الأداء' : 'Performance Analytics'}
        </CardTitle>
        <CardDescription>
          {language === 'ar' 
            ? 'تحليل مفصل لأداء حملاتك وعائد الاستثمار'
            : 'Detailed analysis of your campaign performance and ROI'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-20 space-y-6">
          <div className="h-24 w-24 mx-auto rounded-full bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center shadow-md">
            <BarChart3 className="h-12 w-12 text-purple-500" />
          </div>
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-foreground">
              {language === 'ar' ? 'التحليلات المتقدمة قريباً' : 'Advanced Analytics Coming Soon'}
            </h3>
            <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">
              {language === 'ar' 
                ? 'نعمل على تطوير تحليلات متقدمة لمساعدتك في فهم أداء حملاتك بشكل أفضل وتحسين استراتيجياتك التسويقية'
                : 'We are working on advanced analytics to help you better understand your campaign performance and optimize your marketing strategies'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
